import {API_DRIVER} from "../configs/axios";

const PrivacyService = {
    getPrivacy: (username) => {
        return API_DRIVER.get("/api-privacy/?username=" + username, {
            withCredentials: false, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    },
    getPrivacyMessage: () => {
        return API_DRIVER.get("/api-privacy/popup-html", {
            withCredentials: false, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    },
    acceptPrivacy: (username) => {
        return API_DRIVER.post("/api-privacy", {username: username}, {
            withCredentials: false, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    },
}

export default PrivacyService
